import { render, staticRenderFns } from "./DiscountChangeHistoryTable.vue?vue&type=template&id=7cae79b8"
import script from "./DiscountChangeHistoryTable.vue?vue&type=script&lang=js"
export * from "./DiscountChangeHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports